import { Modal, ModalBody, ModalFooter, ModalHeader } from "../../component/generic-components.tsx"
import { FileFeatureFactItem } from "@dialogics/shared/dto/types.ts"
import { useEffect, useMemo, useState } from "react"
import { useLazyGetFileFeatureQuery } from "../file-feature/service.ts"
import { useGetFeaturesQuery } from "../feature/service.ts"
import { Feature } from "@prisma/client"
import { useProfileQuery } from "../auth/service.ts"
import { useGetCallTypesByDepartmentQuery } from "../call-type/service.ts"
import { FaCircleCheck, FaCircleXmark } from "react-icons/fa6"
import { useSelection } from "../../app/department-context.tsx"

interface FactDetailsModalProps {
  isOpen: boolean
  onClose: () => void
  data?: {
    criteria: { name: string; score: number }
    file_id: number
  }
}

const FactDetailsModal = ({ isOpen, onClose, data }: FactDetailsModalProps) => {
  const [expanded, setExpanded] = useState<string | null>(null)
  const [getFileFeature, { data: fileFeature }] = useLazyGetFileFeatureQuery()
  const { data: allAvailableCriteria = [] } = useGetFeaturesQuery()
  const profile = useProfileQuery()
  const { selectedDepartment } = useSelection()
  const { data: callTypes = [] } = useGetCallTypesByDepartmentQuery(
    {
      departmentId: selectedDepartment?.id,
    },
    {
      skip: !profile,
    },
  )

  const featureMap = useMemo(
    () =>
      allAvailableCriteria.reduce<Record<string, Feature>>((acc, val) => {
        acc[val.code] = val
        return acc
      }, {}),
    [allAvailableCriteria],
  )

  const callTypesMap = useMemo(() => {
    const baseFacts = profile?.data?.organization?.organization_group?.base_facts_description?.baseFacts
    return callTypes.reduce((acc, val) => {
      acc[val.code] = {
        ...val,
        facts: {
          ...baseFacts,
          ...(val.facts_description?.facts || {}),
        },
      }
      return acc
    }, {})
  }, [callTypes, profile?.data?.organization?.organization_group?.base_facts_description])

  useEffect(() => {
    if (data?.file_id && isOpen) {
      getFileFeature(data.file_id)
    }
  }, [data?.file_id, isOpen, getFileFeature])

  const factsMap = useMemo(() => {
    return fileFeature?.facts.facts.reduce<Record<string, FileFeatureFactItem>>((acc, val) => {
      acc[val.code] = val
      return acc
    }, {})
  }, [fileFeature?.facts.facts])

  if (!data || !factsMap || !callTypesMap) {
    return null
  }
  const { criteria } = data
  return (
    <Modal isOpen={isOpen} onClose={onClose} classNames={"w-11/12 max-w-5xl"}>
      <ModalHeader>
        <div className="flex justify-between items-center">
          <h3 className="text-lg font-bold">Детали по критерию</h3>
          <button className="btn btn-sm btn-circle btn-ghost" onClick={onClose}>
            ✕
          </button>
        </div>
      </ModalHeader>
      <ModalBody>
        <div className="max-h-[70vh] overflow-y-auto">
          <div className="join join-vertical bg-base-100 w-full">
            {fileFeature?.features?.features.map(feature => {
              const scoreColor =
                feature.value >= 0.8 ? "bg-green-500" : feature.value >= 0.5 ? "bg-yellow-500" : "bg-red-500"
              const backdropClass = feature.value === 0 ? "bg-red-500" : "bg-gray-200"
              return (
                <div className="collapse collapse-arrow join-item border-base-300 border" key={feature.code}>
                  <input type="radio" name="my-accordion-2" />
                  <summary className="collapse-title font-semibold">
                    <div className="flex justify-between items-center mb-1">
                      <span className="truncate" title={criteria.name}>
                        {featureMap[feature.code].title}
                      </span>
                      <span className="font-bold">{(feature.value * 100).toFixed(0)}%</span>
                    </div>
                    <div className={`w-full ${backdropClass} rounded-full h-1.5 dark:bg-gray-700`}>
                      <div
                        className={`${scoreColor} h-1.5 rounded-full`}
                        style={{ width: `${feature.value * 100}%` }}
                      ></div>
                    </div>
                  </summary>
                  <div className="collapse-content text-sm">
                    <table className="table w-full">
                      <thead>
                        <tr>
                          <th />
                          <th>Факт</th>
                          <th>Значение</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Object.keys(callTypesMap[fileFeature.call_type_ref?.code]?.facts?.[feature.code] || {})
                          .filter(fact => !!factsMap[fact])
                          .map(fact => {
                            console.log(123, factsMap[fact]?.title)
                            return (
                              <tr key={fact}>
                                <td>
                                  <button
                                    className="btn btn-xs btn-circle btn-outline ml-2"
                                    onClick={() => setExpanded(expanded === fact ? null : fact)}
                                  >
                                    +
                                  </button>
                                </td>
                                <td>
                                  {factsMap[fact]?.title}

                                  {expanded === fact && (
                                    <div className={"flex flex-col gap-4 items-stretch content-stretch m-4"}>
                                      {factsMap[fact].references.map((ref, index) => (
                                        <blockquote className={"alert text-xs p-4 ms-4 me-4"} key={index}>
                                          {ref}
                                        </blockquote>
                                      ))}
                                    </div>
                                  )}
                                </td>
                                <td className={factsMap[fact]?.value ? "text-green-500" : "text-red-500"}>
                                  {factsMap[fact]?.value ? (
                                    <FaCircleCheck className={"w-6 h-6"} />
                                  ) : (
                                    <FaCircleXmark className={"w-6 h-6"} />
                                  )}
                                </td>
                              </tr>
                            )
                          })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <button type="button" className="btn" onClick={onClose}>
          Закрыть
        </button>
      </ModalFooter>
    </Modal>
  )
}

export default FactDetailsModal
